import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cookies.title',
  },
  paragraph1: {
    id: 'cookies.paragraph_1',
  },
  paragraph2: {
    id: 'cookies.paragraph_2',
  },
  paragraph3: {
    id: 'cookies.paragraph_3',
  },
  paragraph4: {
    id: 'cookies.paragraph_4',
  },
  paragraph5: {
    id: 'cookies.paragraph_5',
  },
  paragraph6: {
    id: 'cookies.paragraph_6',
  },
  paragraph7: {
    id: 'cookies.paragraph_7',
  },
  paragraph8: {
    id: 'cookies.paragraph_8',
  },
  paragraph9: {
    id: 'cookies.paragraph_9',
  },
});
